import {
    UniversityIndexRequest,
    UniversitySearchRequest,
    UniversitySubjectsRequest
} from '../../../networking/requests/University';

interface SubjectsKeyParams extends UniversitySubjectsRequest {
    universityId: number;
}

// TODO: check if globally if all ...request are applied then the key functions are called in every Query.ts file

export const UniversityQueryKey = {
    base: (keys: any[]) => ['universities', ...keys],
    index: (filters: UniversityIndexRequest) => UniversityQueryKey.base([filters]),
    details: () => UniversityQueryKey.base(['detail']),
    detail: (id: number) => [...UniversityQueryKey.details(), id],
    search: (request: UniversitySearchRequest) => ['universities', 'search', request],
    find: (ids: number[]) => ['universities', 'find', ids],
    subjects: (params: SubjectsKeyParams) => ['universities', 'subjects', params],
    parts: (universityId: number) => ['universities', 'parts', universityId],
    costs: (universityId: number) => ['universities', 'costs', universityId],
};
